<template>
  <div class="tabs flex">
    <div
      class="tabslist flex ac jc"
      v-for="(i, j) in tabList"
      :key="i.value"
      @click="tabschanges(i.value)"
      :style="{
          background: t2value == i.value ? '#1074DB' : 'transparent',
        }"
    > <img :src="i.img" v-if="i.img" class="imgInl"/>
      <span v-else>{{ i.label }}</span>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    tabList: {
      default: [
        { label: "选项卡一", value: 1 },
        { label: "选项卡二", value: 2 }
      ]
    },
    t2value: {
      default: 1
    }
  },
  data() {
    return {
      t2value: this.t2value
    };
  },
  methods: {
    tabschanges(e) {
      this.t2value = e;
      this.$emit("tabchange", { label: "layout", value: this.t2value });
    }
  }
};
</script>
  
  <style lang="scss" scoped>
  .imgInl{
    width: 1.2rem;
  }
.tabs {
  .tabslist {
    color: white;
    font-size: 0.73vw;
    padding: 0 1rem;
    height: 1.75rem;
    width: auto;
    cursor: pointer;
  }
  background: transparent;
  border-radius: 0.26vw;
  overflow: hidden;
  height: 100%;
}
</style>
  